import { render, staticRenderFns } from "./TriviaAnswers.vue?vue&type=template&id=799f9483&scoped=true&"
import script from "./TriviaAnswers.vue?vue&type=script&lang=js&"
export * from "./TriviaAnswers.vue?vue&type=script&lang=js&"
import style0 from "./TriviaAnswers.vue?vue&type=style&index=0&id=799f9483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f9483",
  null
  
)

export default component.exports